import type { IDisposable } from '@/engine/Utilities/IDisposable';

export class CanvasAttributeObserver implements IDisposable {
  private _mutationObserver: MutationObserver;

  public constructor(canvas: HTMLCanvasElement, attributeName: string, callback: (value: string | null) => void) {
    const mutationCallback = (mutationsList: Array<MutationRecord>): void => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === attributeName) {
          const value = (mutation.target as HTMLCanvasElement).getAttribute(attributeName);
          callback(value);
        }
      }
    };

    this._mutationObserver = new MutationObserver(mutationCallback);

    const config = { attributes: true };
    this._mutationObserver.observe(canvas, config);
  }

  public dispose(): void {
    this._mutationObserver.disconnect();
  }
}
